module.exports = __webpack_public_path__ + "static/media/13.4596a2c7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/13.mp3
// module id = 489
// module chunks = 0